module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Copyright © 2015")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("By Jeff Dwyer")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("The word “Pelican” and the depiction of a pelican are")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("trademarks of Pelican Publishing Company, Inc., and are")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("registered in the U.S. Patent and Trademark Office.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("ISBN 9781455621163")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("E-book ISBN 9781455621170")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('div', {
    staticClass: "frame-2a",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('img', {
    attrs: {
      "alt": "copyrightv2.jpg",
      "src": "Images/copyrightv2.jpg.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-5"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-6"
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-450577db","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 66
// module chunks = 0